import { Collection } from './types/Collection'
import { collectionBase } from 'kat/lib/functions/collection/collectionBase'
import { collectionBaseDefault } from 'kat/lib/functions/collection/collectionBaseDefault'
import { collectionDefault } from './collectionDefault'

export const collectionNames = collectionBase.extends<Collection>({
  ...collectionBaseDefault,
  ...collectionDefault,
})()
